import React from "react";
import styles from "./styles.module.scss";
import { LEGEND_ITEMS } from "./constants";
import { Alert, AlertDescription, AlertTitle } from "@altimateai/lego";
import { Button } from "@altimateai/lego";
import { IconArrowsMaximize, IconArrowsMinimize, IconInfoCircle } from "@tabler/icons-react";

interface StatusItemProps {
  label: string;
  color: string;
}

const StatusItem: React.FC<StatusItemProps> = ({ label, color }) => (
  <div className={styles.statusItem}>
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
      <circle cx="4" cy="4" r="4" fill={color} />
    </svg>
    <span>{label}</span>
  </div>
);

const StatusLegend: React.FC = () => {
  return (
    <div className={styles.statusLegendContainer}>
      <span>Status:</span>
      {LEGEND_ITEMS.map((item, index) => (
        <StatusItem key={index} label={item.label} color={item.color} />
      ))}
    </div>
  );
};

interface HeaderProps {
  isSchedulingEnabled: boolean;
  onToggleFullscreen: () => void;
  isFullscreen: boolean;
}

export const Header: React.FC<HeaderProps> = ({
  isSchedulingEnabled,
  onToggleFullscreen,
  isFullscreen,
}) => {
  return (
    <>
      <div className={styles.headerContainer}>
        <StatusLegend />
        <div className={styles.headerActions}>
          <Button
            variant="outline"
            onClick={onToggleFullscreen}
            title={isFullscreen ? "Exit Fullscreen" : "View in Fullscreen"}
            aria-label={isFullscreen ? "Exit Fullscreen" : "Toggle Fullscreen"}
          >
            {isFullscreen ? (
              <>
                Exit Fullscreen
                <IconArrowsMinimize />
              </>
            ) : (
              <>
                Fullscreen
                <IconArrowsMaximize />
              </>
            )}
          </Button>
        </div>
      </div>
      {!isSchedulingEnabled && (
        <Alert variant={"warning"}>
          <IconInfoCircle className={"al-size-4"} />
          <AlertTitle className={"al-text-base"}>Warehouse Sizing</AlertTitle>
          <AlertDescription>
            Please turn on <strong>&#34;warehouse sizing&#34;</strong> in the{" "}
            <strong>&#34;Autotune&#34;</strong> config above to enable this functionality
          </AlertDescription>
        </Alert>
      )}
    </>
  );
};

export default Header;
